<script lang="ts">
export default {
  name: 'GridToggle',
};
</script>

<script setup lang="ts">
import { StoreMutationType } from '@/types/StoreMutationType';
import { computed, inject } from 'vue';
import { Store } from 'vuex';
import { AppState } from '@/store';
import { LucideGrid3x3 } from 'lucide-vue-next';

// ---------------
// reactive data
// ---------------
const store = inject<Store<AppState>>('store');

// ----------
// computed
// ----------
const gridModeEnabled = computed<boolean | undefined>(() => {
  return store?.state.towerCanvasState.gridModeEnabled;
});

// ----------
// handlers
// ----------
function handleToggleGrid(e: MouseEvent): void {
  e.stopPropagation();
  store?.commit(StoreMutationType.SET_GRID_MODE, !store?.state.towerCanvasState.gridModeEnabled);
}
</script>

<template>
  <div class="tw:self-end tw:py-2">
    <label title="Toggle Grid">
      <input
        type="checkbox"
        name="grid-toggle"
        aria-label="Grid Toggle"
        class="tw:pointer-events-none tw:box-border tw:hidden"
        @click="handleToggleGrid"
      />
      <LucideGrid3x3
        class="button toggle-button tw:border-box tw:pointer-events-auto tw:flex tw:h-10 tw:w-10 tw:cursor-pointer tw:items-center tw:rounded-lg tw:p-2 tw:shadow-lg"
        :class="{ selected: gridModeEnabled }" />
    </label>
  </div>
</template>

<style scoped>
.toggle-button {
  background-color: var(--tower-v2-alt-bg-color);
  border: 1px solid var(--tower-v2-border-color);
}

.selected {
  background-color: var(--tower-v2-tool-selected-color);
}

.button:hover {
  background-color: var(--tower-v2-hover-color);
}
</style>
